<template>
  <div :style="isManager ? { backgroundColor: '#f4f7f9', height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' } : {}">
    <!-- Mobile Search Bar (displayMode === 1) -->
    <v-row v-if="displayMode === 1" class="text-left search-bar ma-0 pa-0 search-bar-min">
      <v-expansion-panels accordion style="z-index: 3">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-icon class="ml-0 mr-3">icon-form_search</v-icon>
            {{$t('__categorySearch')}}
            <template v-slot:actions><v-icon>$expand</v-icon></template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row class="" justify="center">
                <v-menu offset-y :close-on-content-click="false" v-model="menuOpenMobile">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ma-1 pa-0 pt-1" outlined style="border:none; height:34px; min-width:50px; border-radius: 8px; background:#ED6D00" v-bind="attrs" v-on="on">
                      <v-icon color="white" size="20">mdi-filter-menu-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="py-4" style="border-radius: 8px; background: white;">
                    <v-list-item style="width:300px; cursor:pointer">
                      <div class="text-right pt14" style="width:80px">{{$t('__status')}}</div>
                      <v-select class="border pt14 pl-4" dense background-color="white" outlined :placeholder="$t('__select')" style="max-width:196px"
                      :items="memberStatusList" :item-text="'CodeText'" item-value="CodeText" v-model="memberStatusSel"></v-select>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-col class="pa-0 col-7 d-flex align-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#ED6D00" size="18" class="mr-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span style="white-space: pre-line; text-align: left; display: block;">{{ $t('__keywordSearchTooltip') }}</span>
                  </v-tooltip>
                  <v-text-field outlined :placeholder="$t('__keywordSearch')" class="keyword text_field"
                  dense v-model="keyword" background-color="white" style="margin-top: 4px; flex-grow: 1;">
                    <template v-slot:append>
                      <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">icon-form_search</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
                  <v-icon color="white" size="20">mdi-close</v-icon>
                </v-btn>
              </v-row>
              <v-row class="" justify="center">
                <v-btn v-if="canEditJob" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath('/jobAssignment',-1)"><span>{{$t('__newReport')}}</span></v-btn>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <!-- Supervisor View: Employee Stats & Date Selector -->
    <div v-if="isManager" class="manager-dashboard-container px-0 py-4" style="flex-shrink: 0;">
      <!-- Buttons integrated above the table to match Banner style -->
      <v-row class="ma-0 align-center mb-4 px-6">
        <v-btn class="mr-3 filter-btn" depressed
        :class="{ 'white--text': filterMode === 'today', 'unselected-filter-btn': filterMode !== 'today' }"
        :color="filterMode === 'today' ? '#ED6D00' : 'white'"
        @click="setFilterMode('today')">
          {{ $t('__today') }}
        </v-btn>
        <v-btn class="mr-3 filter-btn" depressed
        :class="{ 'white--text': filterMode === 'all', 'unselected-filter-btn': filterMode !== 'all' }"
        :color="filterMode === 'all' ? '#ED6D00' : 'white'"
        @click="setFilterMode('all')">
          {{$t('__all')}}
        </v-btn>
        <v-menu transition="scale-transition" offset-y min-width="auto" :close-on-content-click="false" v-model="showMonthPicker">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="filter-btn" v-bind="attrs" v-on="on" depressed
            :class="{ 'white--text': filterMode === 'month', 'unselected-filter-btn': filterMode !== 'month' }"
            :color="filterMode === 'month' ? '#ED6D00' : 'white'">
              {{ filterMonth || 'YYYY-MM' }}
            </v-btn>
          </template>
          <v-date-picker class="datePicker" style="border-radius: 8px;" v-model="filterMonth"
            type="month" color="#ED6D00" no-title scrollable :allowed-dates="allowedMonths"
            @input="showMonthPicker = false; setFilterMode('month')"
          ></v-date-picker>
        </v-menu>
      </v-row>

      <div id="listTable" class="ma-0" :style="isManager ? { height: '25vh' } : { minHeight: 'auto' }">
        <v-simple-table fixed-header :style="isManager ? { height: '100%', overflowY: 'auto' } : {}">
          <template v-slot:default>
            <thead>
              <tr class="text-center">
                <th class="text-center">{{$t('__seName')}}</th>
                <th class="text-center"></th>
                <th class="text-center">{{ $t('__efficient') }}</th>
                <th class="text-center">{{ $t('__urgent') }}</th>
                <th class="text-center">{{ $t('__unfinishedTask') }}</th>
                <th class="text-center">{{ $t('__closed') }}</th>
                <th class="text-center">{{$t('__all')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(stat, index) in staffStats" :key="index" id="table_body_narrow"
              :class="{ 'selected-staff-row': selectedStaff === stat.name }" @click="selectStaff(stat.name)">
                <td class="text-center staff-name" style="min-width: 160px">
                  <v-icon v-if="stat.isMe" color="#ED6D00" size="21" class="mr-2">mdi-crown-circle-outline</v-icon>
                  {{ stat.name }}
                </td>
                <td class="text-center" style="min-width: 60px">
                  <v-menu bottom open-on-hoveroffset-y:close-delay="200"
                  content-class="contact-tooltip" transition="fade-transition" z-index="1000">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mail-btn" icon color="#ED6D00" v-bind="attrs" v-on="on" @click.stop="">
                        <v-icon size="20" color="white">mdi-email-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card class="pa-2 contact-tooltip-content" elevation="0">
                      <div class="tooltip-header mb-1">
                        <strong>{{ stat.name }}</strong>
                      </div>
                      <v-divider class="mb-1"></v-divider>
                      <div class="d-flex align-center mb-1 tooltip-item clickable-tooltip-item" :title="$t('__clickCopy')"
                      @click.stop="copyToClipboard(stat.email)">
                        <v-icon small color="#555" class="mr-2">mdi-email-outline</v-icon>
                        <span class="selectable-text">{{ stat.email || '-' }}</span>
                      </div>
                      <div class="d-flex align-center tooltip-item clickable-tooltip-item" :title="$t('__clickCopy')"
                      @click.stop="copyToClipboard(stat.phone)">
                        <v-icon small color="#555" class="mr-2">mdi-phone</v-icon>
                        <span class="selectable-text">{{ stat.phone || '-' }}</span>
                      </div>
                    </v-card>
                  </v-menu>
                </td>
                <td class="text-center content" style="min-width: 120px">{{ stat.efficient }}</td>
                <td class="text-center content" :style="{ color: stat.urgent > 0 ? 'red' : 'inherit', fontWeight: stat.urgent > 0 ? 'bold' : 'normal' }" style="min-width: 65px">{{ stat.urgent }}</td>
                <td class="text-center content" style="min-width: 80px">{{ stat.unfinished }}</td>
                <td class="text-center content" style="min-width: 80px">{{ stat.closed }}</td>
                <td class="text-center content" style="min-width: 65px">{{ stat.total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <!-- Job List Filter Banner -->
    <v-row v-if="displayMode === 0" class="text-left search-bar search-bar-max ma-0" style="flex-shrink: 0;">
      <v-col cols="8" class="pl-8 pa-0" style="display: flex; align-items: center;">
        <v-row class="my-0 align-center" style="align-content: center">
          <v-menu offset-y :close-on-content-click="false" v-model="menuOpen">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ma-1 pa-0 pt-1" outlined style="border:none; height:34px; min-width:50px; border-radius: 8px; background:#ED6D00" v-bind="attrs" v-on="on">
                <v-icon color="white" size="20">mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
            <v-list class="py-4" style="border-radius: 8px; background: white;">
              <v-list-item style="width:300px; cursor:pointer">
                <div class="text-right pt14" style="width:80px">{{$t('__status')}}</div>
                <v-select class="border pt14 pl-4" dense background-color="white" outlined :placeholder="$t('__select')" style="max-width:196px"
                :items="memberStatusList" :item-text="'CodeText'" item-value="CodeText" v-model="memberStatusSel"></v-select>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-col class="pa-0 col-5 d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#ED6D00" size="18" class="mr-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span style="white-space: pre-line; text-align: left; display: block;">{{ $t('__keywordSearchTooltip') }}</span>
            </v-tooltip>
            <v-text-field outlined :placeholder="$t('__keywordSearch')" class="mt-2 keyword text_field"
            dense v-model="keyword" background-color="white">
              <template v-slot:append>
                <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                icon-form_search
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
            <v-icon color="white" size="20">mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="4" class="pr-8 pa-0 d-flex justify-end align-center">
        <!-- Currently selected Staff Banner (Supervisor Mode) -->
        <div v-if="selectedStaff" class="selected-staff-banner d-inline-flex align-center mr-4" style="background-color: #FFF3E0; border: 1px solid #ED6D00; color: #ED6D00;">
          <span class="mr-2">{{ $t('__currentlySelected') }}: <strong>{{ selectedStaff }}</strong></span>
          <v-icon small color="#ED6D00" @click="clearStaff" class="close-staff-icon">mdi-close-circle</v-icon>
        </div>
        <v-btn v-if="canEditJob" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath('/jobAssignment',-1)"><span>{{$t('__newReport')}}</span></v-btn>
      </v-col>
    </v-row>

    <div id="router" class="ma-0 pa-0" :style="isManager ? { flex: '1 1 auto', display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' } : viewStyle">
      <!-- Scrollable table container -->
      <div id="listTable" class="ma-0" :style="isManager ? { flex: '1 1 auto', display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' } : {}">
        <div :style="isManager ? { flex: '1 1 auto', overflowY: 'auto' } : {}">
          <v-simple-table fixed-header class="custom-supervisor-table">
          <template v-slot:default>
            <thead>
              <tr class="text-center">
                <th class="text-center">{{$t('__edit')}}</th>
                <th @click="sort('no')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('caseId')">{{$t('__caseId')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('customer')">{{$t('__customer')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('item')">{{$t('__item')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('reporter')">{{$t('__reporter')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('createTime')">{{$t('__createTime')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('updateTime')">{{$t('__updateTime')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('durationDays')">{{$t('__duration')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('assigned')">{{$t('__assigned')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('status')">{{$t('__jobStatus')}}<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index" id="table_body">
                <td class="text-center" style="min-width:150px">
                  <v-avatar color="#979491" size="30" tile @click="$refs.PdfDownload.open(data.id,'assignment', data.caseId)"
                    class="mr-1 action-btn-pdf" style="cursor: pointer;">
                    <div style="width: 24px; padding-top:2px">
                      <v-img :src="images.PDF" alt="PDF icon"></v-img>
                    </div>
                  </v-avatar>
                  <v-avatar color="#ED6D00" size="30" tile @click="redirectPath('/jobAssignment', data.id)" 
                    class="mr-1 action-btn-edit" style="cursor: pointer;">
                    <v-icon color="#FFFFFF" size="28">icon-form_edit_tap</v-icon>
                  </v-avatar>
                  <v-avatar v-if="canEditJob" color="#4C4948" size="30" tile @click="confirmDelete(data.id)"
                    class="action-btn-delete" style="cursor: pointer;">
                    <v-icon color="#FFFFFF" size="20">mdi-delete</v-icon>
                  </v-avatar>
                </td>
                <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                <td style="min-width:120px"><h4 class="content">{{data.caseId}}</h4></td>
                <td style="min-width:120px"><h4 class="content">{{data.customer}}</h4></td>
                <td style="min-width:145px"><h4 class="content">{{data.item}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.reporter}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.createTimeString}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.updateTimeString}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.durationDays}}</h4></td>
                <td style="min-width:120px"><h4 class="content">{{data.assigned}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.status}}</h4></td>
              </tr>
            </tbody>
          </template>
          </v-simple-table>
        </div>
      </div>
    
      <v-row class="ma-0 px-4 justify-center justify-lg-end">
        <v-col cols="12" lg="6" class="pa-0"></v-col>
        <v-col cols="12" lg="6">
          <v-row class="ma-0 align-center" style="justify-content: center">
            <v-col cols="12" lg="auto" class="d-none d-lg-flex align-center">
              {{ $tc('__totalCount', pagination.totalCount, { count: pagination.totalCount }) }}
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center">
              <v-pagination color="#ED6D00" :total-visible="5" :length="pagination.totalPage" v-model="pagination.page"/>
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center justify-lg-end align-center">
              <span class="mr-2">{{ $t('__go') }}</span>
              <v-text-field class="mx-1 text-center" min="1" :max="pagination.totalPage" type="number"
              dense outlined hide-details style="max-width: 80px" @keyup.enter="setDestPage()" v-model="destPage"/>
              <span class="ml-1">{{ $t('__page') }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <ShowConfirm ref="ShowConfirm" :onSave="deleteJobAssignment" />
    <ShowMsg ref="ShowMsg" />
    <PdfDownload ref="PdfDownload"/>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowConfirm from '@/dialogs/ShowConfirm'
import ShowMsg from '@/dialogs/ShowMsg'
import PdfDownload from '@/dialogs/PdfDownload'
import { getRoles, getEmployeeName, getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'JobAssignmentList',
  components: {ShowConfirm, ShowMsg, PdfDownload},
  mounted(){
    this.language = i18n.locale
    this.$Global.getStatusList().then(res=>{ this.memberStatusList = res })
    this.initSupervisorData()
    
    // Check for staff filter from dashboard
    if (this.$route.query.staff) {
      this.selectedStaff = this.$route.query.staff
    }

    this.getDataset()
    this.destPage = this.pagination.page
  },
  data:() => ({
    select:'',
    keyword:'',
    language:'',
    datasets: [],
    pagination:{page:1,totalPage:1,totalCount:0},
    pageSize: 10,
    orderBy:'id',
    direction:'desc',
    destPage:'',
    viewStyle:{},
    displayMode:'',

    memberStatusList: [],
    memberStatusSel:'',

    menuOpen: false,
    menuOpenMobile: false,
    deleteId: null,

    // Supervisor View Data
    allJobs: [],
    allEmployees: [],
    selectedStaff: '',
    filterMode: 'today', // 'today', 'month', 'all'
    filterMonth: new Date().toISOString().substr(0, 7), 
    showMonthPicker: false,

    images:{
      PDF: require('@/assets/image/PDF.png'),
    },
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    this.$root.$on('language',(value)=>{
      this.language = value
    })
  },
  watch:{
    "pagination.page":function(val){
      this.destPage = val
      this.getDataset()
    },
    "memberStatusSel":function(){
      this.getDataset()
      this.menuOpen = false
      this.menuOpenMobile = false
    },
    "keyword":function(){
      this.getDataset()
    },
    "filterMonth": function() {
      if (this.filterMode === 'month') {
        this.refreshStatsAndData()
      }
    },
    "$route.query.staff": function(val) {
      if (val !== undefined) {
        this.selectedStaff = val
        this.pagination.page = 1
        this.getDataset()
      }
    }
  },
  computed: {
    canEditJob() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'JobAssignment')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    },
    isManager() {
      return getRoles().isManager
    },
    staffStats() {
      if (!this.isManager) return []
      
      const statsMap = {}
      const myName = getEmployeeName()
      
      // Initialize with all staff
      this.allEmployees.forEach(emp => {
        const name = (emp.name || emp.Account || '').trim()
        if (!name) return

        const roleStr = emp.role || emp.roles || ''
        const roles = roleStr.split(',').map(r => r.trim()).filter(Boolean)
        // 過濾掉單純 role 只有 sales 的人，或是完全沒有 role 的人
        if (roles.length === 0 || (roles.length === 1 && roles[0].toLowerCase() === 'sales')) {
          return
        }

        statsMap[name] = {
          name: name,
          email: emp.account || emp.email || emp.mail || '',
          phone: emp.phone || emp.mobile || '',
          efficient: 0,
          urgent: 0,
          unfinished: 0,
          closed: 0,
          total: 0,
          durations: [],
          isMe: name === myName
        }
      })

      // Add persons from jobs if not in employee list
      this.allJobs.forEach(job => {
        if (!job.assigned) return
        const key = job.assigned.trim()

        // 檢查是否為單純 role 只有 sales 的人，或是完全沒有 role 的人，如果是則略過不加入清單
        const matchedEmp = this.allEmployees.find(e => (e.name || e.Account || '').trim() === key)
        if (matchedEmp) {
          const roleStr = matchedEmp.role || matchedEmp.roles || ''
          const roles = roleStr.split(',').map(r => r.trim()).filter(Boolean)
          if (roles.length === 0 || (roles.length === 1 && roles[0].toLowerCase() === 'sales')) {
            return
          }
        }

        if (!statsMap[key]) {
          statsMap[key] = {
            name: key,
            email: '',
            phone: '',
            efficient: 0,
            urgent: 0,
            unfinished: 0,
            closed: 0,
            total: 0,
            durations: [],
            isMe: key === myName
          }
        }
        
        const s = statsMap[key]
        
        // Collect duration for ALL relevant jobs (active + filtered closed)
        const dValue = job.durationDays !== undefined && job.durationDays !== null ? job.durationDays : job.duration
        if (dValue !== undefined && dValue !== null) {
          const d = parseFloat(dValue)
          if (!isNaN(d)) s.durations.push(d)
        }

        if (job.isClosed) {
          s.closed++
        } else {
          s.unfinished++
          // Urgent: unfinished tasks with durationDays > 7 or status includes 'urgent'
          if ((dValue && parseFloat(dValue) > 7) || (job.status && job.status.toLowerCase().includes('urgent'))) {
            s.urgent++
          }
        }
        s.total = s.closed + s.unfinished
      })

      // Calculate efficiency
      Object.values(statsMap).forEach(s => {
        if (s.durations.length > 0) {
          const avg = s.durations.reduce((a, b) => a + b, 0) / s.durations.length
          s.efficient = avg % 1 === 0 ? avg : avg.toFixed(1)
        } else {
          s.efficient = '-'
        }
      })

      // Respect the order from allEmployees (backend sorted by name priority)
      const orderedStats = []
      this.allEmployees.forEach(emp => {
        const name = (emp.name || emp.Account || '').trim()
        if (statsMap[name]) {
          orderedStats.push(statsMap[name])
          delete statsMap[name]
        }
      })
      
      // Add anyone remaining in statsMap (who might not be in the employee list but has jobs)
      Object.values(statsMap).forEach(s => {
        orderedStats.push(s)
      })

      return orderedStats
    }
  },
  methods:{
    allowedMonths(date) {
      // date 會是 'YYYY-MM' 或 'YYYY-MM-DD'
      const current = new Date()
      
      // 當前月（設為1號避免日期問題）
      const currentMonth = new Date(current.getFullYear(), current.getMonth(), 1)

      // 可選範圍
      const min = new Date(currentMonth)
      min.setMonth(min.getMonth() - 6)

      const max = new Date(currentMonth)
      max.setMonth(max.getMonth() + 2)

      // 使用者選的日期
      const selected = new Date(date)

      return selected >= min && selected <= max
    },
    async initSupervisorData() {
      if (!this.isManager) return
      try {
        const empRes = await this.$http.get('/EmployeeList', { 
          params: { 
            pageSize: 9999, 
            currentPage: 1,
            orderBy: 'name',
            isNamePriority: true,
            direction: 'asc'
          } 
        })
        this.allEmployees = empRes.data.Data || empRes.data.data || []
        this.refreshStatsAndData()
      } catch (e) {
        console.error('Failed to init supervisor data', e)
      }
    },
    async refreshStatsAndData() {
      if (!this.isManager) return
      const params = { pageSize: 9999, currentPage: 1 }
      try {
        // Fetch Active and Closed jobs to calculate full stats
        const [activeRes, closedRes] = await Promise.all([
          this.$http.get('/GetJobAssignmentListByIdentity', { params }),
          this.$http.get('/GetClosedJobAssignmentListByIdentity', { params })
        ])
        
        const activeData = (activeRes.data.Data || activeRes.data.data || []).map(j => ({ ...j, isClosed: false }))
        const closedOriginalData = (closedRes.data.Data || closedRes.data.data || []).map(j => ({ ...j, isClosed: true }))
        
        const now = new Date()
        const todayStr = now.getFullYear() + '/' + String(now.getMonth() + 1).padStart(2, '0') + '/' + String(now.getDate()).padStart(2, '0')
        let filteredClosed = []

        // Filtering logic for stats:
        // 1. Unfinished Tasks: Always show ALL current active tasks (no date filter)
        // 2. Closed / Efficient: Respect Today/Month/Total filter, uses closeDateString
        
        if (this.filterMode === 'today') {
          filteredClosed = closedOriginalData.filter(j => j.closeDateString && j.closeDateString.startsWith(todayStr))
        } else if (this.filterMode === 'month') {
          const monthStr = this.filterMonth.replace('-', '/')
          filteredClosed = closedOriginalData.filter(j => j.closeDateString && j.closeDateString.startsWith(monthStr))
        } else {
          // 'all' mode: include everything
          filteredClosed = closedOriginalData
        }

        // Combine ALL active tasks with filtered closed tasks for stats
        this.allJobs = [...activeData, ...filteredClosed]
        
        this.getDataset()
      } catch (e) {
        console.error('Failed to fetch jobs for stats', e)
      }
    },
    setFilterMode(mode) {
      if (this.filterMode === mode && mode === 'today') return
      this.filterMode = mode
      this.refreshStatsAndData()
    },
    selectStaff(name) {
      this.selectedStaff = (this.selectedStaff === name) ? '' : name
      this.pagination.page = 1
      this.getDataset()
    },
    clearStaff() {
      this.selectedStaff = ''
      this.pagination.page = 1
      this.getDataset()
    },
    copyToClipboard(text) {
      if (!text || text === '-') return
      navigator.clipboard.writeText(text).then(() => {
        // Silently copy without popup as requested
      }).catch(err => {
        console.error('Copy failed:', err)
      })
    },
    close(){
      this.keyword = ''
      this.memberStatusSel = ''
      this.selectedStaff = ''
      this.menuOpen = false
      this.menuOpenMobile = false
      this.getDataset()
    },
    calculateWindows(){
      let baseHeight = window.innerHeight - 128
      if (this.isManager) {
        this.viewStyle = { height: (baseHeight / 2) - 150 + 'px' }
      } else {
        this.viewStyle = { height: baseHeight + 'px' }
      }
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    redirectPath(path, id){
      let tmp = {
        keyword: this.keyword,
        memberStatusSel: this.memberStatusSel,
      }
      sessionStorage.setItem('search',JSON.stringify(tmp))
      sessionStorage.removeItem('isClosedJob')
      this.$router.push({path: path, query: {id: id, page: this.pagination.page}})
    },
    setDestPage(){
      let page = parseInt(this.destPage)
      if (isNaN(page) || page < 1) {
        page = 1
      }
      if (page > this.pagination.totalPage) {
        page = this.pagination.totalPage
      }
      this.destPage = page
      if (this.pagination.page === page) {
        this.getDataset()
      } else {
        this.pagination.page = page
      }
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/GetJobAssignmentListByIdentity',
        params: {
          'orderBy': self.orderBy,
          'direction': self.direction,
          'pageSize': 10,
          'currentPage': self.pagination.page,
          'limit': self.pageSize,
          'keyword':self.keyword != ''? self.keyword: null,
          'status':self.memberStatusSel != ''? self.memberStatusSel: null,
          'assigned': self.selectedStaff != '' ? self.selectedStaff : null
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.Data || []
        self.pagination.totalPage = response.data.TotalPageCount
        self.pagination.totalCount = response.data.TotalCount
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'Job-7980' }))
      })
    },
    confirmDelete(id) {
      this.deleteId = id
      this.$refs.ShowConfirm.open(2, null, null, true)
    },
    deleteJobAssignment() {
      if (!this.deleteId) return
      var self = this
      var request = {
        method: 'POST',
        url: '/DeleteJobAssignment',
        headers: { 'Content-Type': 'application/json-patch+json' },
        data: { id: this.deleteId }
      }
      this.$http(request).then(function(response) {
        self.deleteId = null
        self.getDataset()
        self.$refs.ShowMsg.open(4)
        if (self.isManager) self.refreshStatsAndData()
      }).catch((error) => {
        var errorMsg = error.response?.data?.Message || '刪除失敗'
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        self.deleteId = null
      })
    },
  }
}
</script>

<style>
  @media (min-width: 960px) {
    .search-bar-min { display: none !important; }
  }
  @media (max-width: 959px) {
    .search-bar-max, .pagination-max { display: none !important; }
  }
  .action-btn-pdf:hover, .action-btn-edit:hover, .action-btn-delete:hover { opacity: 0.8; }

  /* Supervisor Styles */
  .manager-dashboard-container { background-color: #f4f7f9; }
  .filter-btn { height: 34px !important; border-radius: 8px !important; text-transform: none !important; border: 1px solid #ED6D00 !important; }
  .unselected-filter-btn { color: #ED6D00 !important; border: 1px solid #ccc !important; }
  .selected-staff-row { background-color: #FFF3E0 !important; outline: 2px solid #ED6D00; }
  .selected-staff-row td:first-child { border-left: 2px solid #ED6D00 }
  .selected-staff-row td:last-child { border-right: 2px solid #ED6D00}
  .staff-name { font-weight: 500; color: #4C4B49; }
  .mail-btn { background-color: #ED6D00 !important; width: 32px !important; height: 32px !important; border-radius: 8px !important; }
  .selected-staff-banner { background-color: #f5f5f5; padding: 6px 12px; border-radius: 8px; border: 1px solid #ddd; font-size: 14px; }
  .close-staff-icon { cursor: pointer; }
  .close-staff-icon:hover { color: #ED6D00 !important; }

  /* Override Main.css IDs for specific stats behavior */
  #listTable.ma-0 {
    width: calc(100% - 48px) !important;
    margin: 15px 24px 5px 24px !important;
  }
  #listTable.ma-0 thead tr th {
    color: rgba(0, 0, 0, 0.87) !important;
    font-size: 0.9rem !important;
  }

  /* Tooltip Styling */
  .contact-tooltip {
    opacity: 1 !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
    border-radius: 12px !important;
    padding: 0 !important;
    border: 1px solid #eee !important;
  }
  .contact-tooltip-content {
    color: #444;
    min-width: 220px;
    background-color: white !important;
  }
  .tooltip-header {
    font-size: 16px;
    color: #444;
    text-align: center;
    padding: 4px 12px;
  }
  .tooltip-item {
    font-size: 14px;
    padding: 4px 12px;
  }
  .tooltip-item span {
    word-break: break-all;
  }
  .selectable-text {
    user-select: text !important;
    cursor: text;
  }
  .clickable-tooltip-item {
    cursor: pointer !important;
    transition: background-color 0.2s;
    border-radius: 6px;
  }
  .clickable-tooltip-item:hover {
    background-color: #f0f0f0;
  }

  .centered-input >>> input {
    text-align: center;
  }
  .centered-input >>> input[type=number] {
    -moz-appearance: textfield;
  }
</style>
